import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../../../layouts/Default";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Title } from "../../../../themes/Default/components/Title";
import { Main } from "../../../../themes/Default/components/Main";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { List } from "../../../../themes/Default/components/List";
import { TableHead } from "../../../../themes/Default/components/List/components/Body/components/TableHead";
import { TableBody } from "../../../../themes/Default/components/List/components/Body/components/TableBody";
import { TableRow } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableDataCell } from "../../../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { groupsManagement } from "../../../../hooks/api/GroupsManagement";
import { Slide, ToastContainer } from "react-toastify";
import { Header as ListHeader } from "../../../../themes/Default/components/List/components/Header";
import { Menu as ListMenu } from "../../../../themes/Default/components/List/components/Header/components/Menu";
import { Title as ListTitle } from "../../../../themes/Default/components/List/components/Header/components/Title";
import { BodyAttendance } from "../../../../themes/Default/components/List/components/Body";
import { groupProgressManagement } from "../../../../hooks/api/GroupProgressManagement/GroupProgressManagement";
import { generateStep } from "../../../../services/core/Group/GroupProgress";
import { useUserToken } from "../../../../hooks/core/UserToken";
import { roles } from "../../../../services/utils/Roles";

const Progrees = () => {
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const { groupId } = useParams();
    const { useViewGroupMutation, useListAttendancesMutation, useProgressListMutation } = groupsManagement;
    const [attendancesList, { isLoading }] = useListAttendancesMutation();
    const [students, setStudents] = useState();
    const [groupName, setGroupName] = useState("");
    const [viewGroup] = useViewGroupMutation();
    const [groupClassNumber, setGroupClassNumber] = useState();
    const [step, setStep] = useState();
    const [progressSteps, setProgressSteps] = useState([]);

    const { useGroupProgressByGroupTypeMutation } = groupProgressManagement;
    const [groupProgress] = useGroupProgressByGroupTypeMutation();
    const [totalColumns, setTotalColumns] = useState();
    const [listProgress] = useProgressListMutation();
    const [totalProgressByStudent ,setTotalProgressByStudent] = useState();
    const [groupPassedClasses, setGroupPassedClasses] = useState();
    const [hasTests, setHasTests] = useState(false);
    const [hasReport, setHasReport] = useState(false);
    const [hasPlan, setHasPlan] = useState(false);

    const tabs = [
        { title: t('groups.attendance'),onClick: () => gotoAttendanceTab(groupId)  },
        ...(hasPlan ? [
            { title: t('groups.planning'), onClick: () => gotoPlanningTab(groupId)},
        ] : []),
        { title: t('groups.progress'),isActive: true },
        ...(hasTests ? [
            { title: t('groups.progressTest'), onClick: () => gotoProgressTestsTab(groupId) }
        ] : []),
        ...(hasReport ? [
            { title: t('reports.title'),onClick: () => gotoReportTab(groupId)},
        ] : []),
        { title: t('documents'), onClick: () => gotoDocumentsTab(groupId)},
        { title: t('notes'), onClick: () => gotoNotesTab(groupId)},
    ];

    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();
    if (
        decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
        decodedToken?.roles.includes(roles.SECRETARY) ||
        decodedToken?.roles.includes(roles.DIRECTOR) || 
        decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES)
    ) {
        tabs.push({
            title: t("settings.title"),
            onClick: () => gotoEditTab(groupId),
        });
    }

    const gotoPlanningTab = (groupId) => {
        navigate("/groups/" + groupId + "/planning");
    }

    const gotoProgressTestsTab = (groupId) => {
        navigate("/groups/" + groupId + "/tests");
    }

    const gotoReportTab = (groupId) => {
        navigate("/groups/" + groupId + "/reports");
    }

    const gotoNotesTab = (groupId) => {
        navigate("/groups/" + groupId + "/notes");
    }

    const gotoDocumentsTab = (groupId) => {
        navigate("/groups/" + groupId + "/documents");
    }

    const gotoAttendanceTab = (groupId) => {
        navigate("/groups/" + groupId + "/attendance");
    }

    const gotoEditTab = (groupId) => {
        navigate("/groups/edit/" + groupId);
    }

    const gotoAddProgress = (studentId, classNumber) => {
        navigate("/groups/" + groupId + "/progress/student/" + studentId + "/classNumber/" + classNumber);
    }

    useEffect(() => {
        Promise.all([
          attendancesList({ groupId }),
          viewGroup(groupId)
        ]).then(([attendancesResult, groupResult]) => {
          setStudents(attendancesResult?.data?.students);
          setGroupName(groupResult?.data?.name);
          setHasTests(groupResult?.data?.hasTests);
          setHasReport(groupResult?.data?.hasReport);
          setHasPlan(groupResult?.data?.hasPlan);
          setGroupPassedClasses(groupResult?.data?.passedClasses);
          setGroupClassNumber(groupResult?.data?.classNumber);
          const totalClasses = groupResult?.data?.classNumber;
          const half = Math.ceil(totalClasses / 2);

          setProgressSteps([half, totalClasses]);
      
          groupProgress({ groupTypeId: groupResult?.data?.type }).then((res) => {
            setTotalColumns(res?.data?.totalRecords);
          });
        });
    }, [groupId]);
      
    useEffect(() => {
        if (!step || !groupClassNumber) return;
      
        const steps = [];
        for (let i = step; i <= groupClassNumber; i += step) {
          steps.push(i);
        }
        setProgressSteps(steps);
      
        Promise.all(
          steps.map(classNumber => listProgress({ groupId, classNumber }))
        ).then(results => {
            const studentOptionsCountByClass = {};

            results.forEach((result, index) => {
            const classNumber = steps[index]; 
            const data = result.data;

            data.forEach(groupProgress => {
                groupProgress.options.forEach(option => {
                    const studentId = option.student;

                    if (!studentOptionsCountByClass[studentId]) {
                        studentOptionsCountByClass[studentId] = {};
                    }
                    if (!studentOptionsCountByClass[studentId][classNumber]) {
                        studentOptionsCountByClass[studentId][classNumber] = 0;
                    }
                    studentOptionsCountByClass[studentId][classNumber]++;
                    });
                });
            });

            setTotalProgressByStudent(studentOptionsCountByClass);
        });
    }, [step, groupClassNumber, groupId]);
      

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/groups" />
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title fullWidth={"100%"}>
                    {groupName}
                </Title>
                <Breadcrumps>
                    <Link title={t("groups.title")} icon="fa-user-group" />
                    <Link title={t("groups.progress")} isActive={true} />
                </Breadcrumps>
                <List>
                    <ListHeader> 
                    <ListMenu>
                        <ListTitle title={"Napredak na kraju: "} />                       
                    </ListMenu>
                          
                    </ListHeader>
                    <BodyAttendance>
                        <TableHead>
                            <TableRow>
                                <TableHeadCell>
                                    <span>{t("groups.no")}</span>
                                </TableHeadCell>
                                <TableHeadCell width="150px">
                                    <span>{t("Status u grupi")}</span>
                                </TableHeadCell>
                                <TableHeadCell width="auto">
                                    <span>{t("groups.fullName")}</span>
                                </TableHeadCell>
                                {progressSteps.map((progressStep, index) => (
                                    <TableHeadCell key={index}>
                                        <span>{progressStep + ". termina"}</span>
                                    </TableHeadCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {students?.length > 0 && (() => {
                            let activeIndex = 0;
                            return students.map((student) => {
                                if (!student.isArchived) activeIndex++;
                                return (
                                    <TableRow key={student.id}>
                                        <TableDataCell>{!student.isArchived ? String(activeIndex).padStart(2, "0") : ''}</TableDataCell>
                                        <TableDataCell>
                                            <span style={{ color: student.isArchived ? '#ff0000' : '#27ae60' }}>
                                                {student.isArchived ? t("Arhiviran") : t("Aktivan")}
                                            </span>
                                        </TableDataCell>
                                        <TableDataCell>
                                            <span style={{ color: student.isArchived ? '#ff0000' : '#27ae60' }}>
                                                {student.name}
                                            </span>
                                        </TableDataCell>
                                        {progressSteps?.length > 0 &&
                                            progressSteps?.map((progressStep, index) => {
                                                const optionsCount = totalProgressByStudent?.[student.id]?.[progressStep] || 0;
                                                return (
                                                    <TableDataCell>
                                                        {(!student.isArchived || (student.isArchived && optionsCount === totalColumns)) && (
                                                            <Button 
                                                                color={
                                                                    optionsCount === totalColumns
                                                                    ? "#27ae60"
                                                                    : optionsCount === totalColumns - 2
                                                                    ? "#f89623"
                                                                    : progressStep < groupPassedClasses
                                                                    ? "#ff0000"
                                                                    : ""
                                                                }
                                                                customClass="cancel-class__button"
                                                                customSpanClass="cancel-class__span"
                                                                icon={"fa-regular fa-eye"}
                                                                onClick={() => gotoAddProgress(student.id, progressStep)}
                                                            />
                                                        )}
                                                    </TableDataCell>
                                                );
                                            })}
                                    </TableRow>
                               );
                            });
                        })()}
                        </TableBody>
                    </BodyAttendance>
                </List>
            </Main>
        </DefaultLayout>
    );
};

export default Progrees;
